import { render, staticRenderFns } from "./StudentHeader.vue?vue&type=template&id=45bca40c&"
import script from "./StudentHeader.vue?vue&type=script&lang=js&"
export * from "./StudentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports